import { render, staticRenderFns } from "./NetworkContainer.vue?vue&type=template&id=bcfa17da&"
import script from "./NetworkContainer.vue?vue&type=script&lang=js&"
export * from "./NetworkContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports